import {gql, useMutation} from "@apollo/client";

const REMOVE_GAME_MUTATION = gql`
mutation DeleteGame($gameId: Int!) {
  deleteGame(gameId: $gameId) {
    success    
  }
}


`;

export default function RemoveGameMutation() {
    return useMutation(REMOVE_GAME_MUTATION);
}